<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <img
      class="report_start_btn"
      @click="pageChange"
      src="@/assets/images/yearReport/btn_点击查看.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    pageChange() {
      this.buriedPoint(2, '年度报告启动页【点击查看】按钮', "年度报告", "年度报告")
      this.$emit("pageChange", 1)
    }
  },
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}

.view_box {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/yearReport/P0.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .report_start_btn {
    position: absolute;
    bottom: 104px;
    right: 170px;
    width: 210px;
    height: 56px;
    cursor: pointer;
  }
}
</style>
